import React from "react";
import BeefreeTemplateBlueprintEditorContainer from "./BeefreeTemplateBlueprintEditorContext";
import BlueprintComposer from "./BlueprintComposer";

const BeefreeTemplateBlueprintEditor = (props) => {
  return (
    <BeefreeTemplateBlueprintEditorContainer {...props}>
      <BlueprintComposer />
    </BeefreeTemplateBlueprintEditorContainer>
  );
};

export default BeefreeTemplateBlueprintEditor;
